/* eslint-disable default-case */
import React, { Component } from 'react';
import './home.less'
import { Notify} from 'zent';
import history from '../../router/history'
class Home extends Component{  
    componentDidMount(){
          
    }
    componentWillUnmount() {
        
      
    }
    constructor(){
        super({});
    }
    test(){
        
    }
    render(){
        return(
            <div className='home'>
                home
            </div>
        )
    }
}
export default Home;